export default [
    "Material",
    "Parameter",
    "Service"
]